"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailTitleInfo = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const InfoTitleStyled = styled_components_1.default.div `
	&.test-info-title,
	&.test-info-title * {
		box-sizing: border-box;
	}
	&.test-info-title {
		background: var(--color-silver, #f3f4f8);
		border-radius: 12px;
		padding: 10px 12px 10px 24px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		min-width: ${props => (props.$isMobile ? 'unset' : '560px')};
		position: relative;
	}
	.title-container {
		display: flex;
		flex-direction: row;
		gap: 8px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		flex: 1;
		overflow: hidden;

		svg {
			min-width: 22px;
		}
	}

	.text-1 {
		text-align: left;
		vertical-align: top;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);

		font-weight: var(--h4-font-weight, 700);
		color: var(--color-black, #101010);
		flex: 1;
		word-break: break-all;
	}

	.title-inline-wrap {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		max-width: 100%;
	}

	.title-status-chip {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 2px 8px;
		border-radius: 6px;
		background: #6c7178;
		color: var(--color-white, #ffffff);
		font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b5-font-size, 12px);
		line-height: var(--b5-line-height, 20px);
		font-weight: 700;
		flex-shrink: 0;
	}

	.title-main-text {
		min-width: 0;
		word-break: break-all;
	}

	.btn-container {
		padding: 0;
		gap: 12px;
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.text-1 {
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 32px);
	}
	margin-bottom: 12px;
`;
const tabletStyles = (0, styled_components_1.css) `
	.text-1 {
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 32px);
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	&.test-info-title {
		gap: 8px;
	}
	.text-1 {
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
		position: relative;

		&.noText {
			.button {
				border-radius: 6px;
				padding: 4px 8px 4px 8px;
				display: flex;
				flex-direction: row;
				gap: 4px;
				align-items: center;
				justify-content: flex-start;
				flex-shrink: 0;
				position: relative;

				p {
					min-width: unset;
					color: var(--color-white, #ffffff);
					text-align: left;
					font-family: var(--b5-font-family, 'NotoSansKr-Regular', sans-serif);
					font-size: var(--b5-font-size, 12px);
					line-height: var(--b5-line-height, 22px);
					letter-spacing: var(--b5-letter-spacing, -0.02em);
					font-weight: var(--b5-font-weight, 400);
					position: relative;
					display: flex;
					align-items: center;
					justify-content: flex-start;
				}
			}
			span {
				position: relative;
			}
		}
	}
`;
exports.DetailTitleInfo = react_1.default.memo(({ name, title, previousPage, children, }) => {
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(InfoTitleStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "test-info-title" },
        react_1.default.createElement("div", { className: "title-container" },
            react_1.default.createElement(common_1.Button, { className: "arrow", option: {
                    buttonBeforeIcon: {
                        show: true,
                        name: 'arrow',
                        size: 28,
                        color: Colors_1.Colors.black,
                    },
                }, onClick: previousPage }),
            typeof title === 'string' ? (react_1.default.createElement("div", { className: "text-1" }, title)) : (react_1.default.createElement("div", { className: "text-1 noText" }, title)),
            name && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(common_1.Icon, { className: "arrow-right", icon: "arrow", size: 22, fill: Colors_1.Colors.black }),
                react_1.default.createElement("p", { className: "text-1 overText" }, name)))),
        children));
});
